import React, { useState, useEffect, useContext } from 'react';
import { DepositState, ExpectedInboundState, ExpectedOutboundState } from '../../api/models';
import { translate } from '../../providers/locale';
import { green, purple, blue, yellow, grey } from '@material-ui/core/colors';
import { Color } from '@material-ui/lab/Alert';

export function getExpectedOutboundStateColor(state: ExpectedOutboundState, contrast = 900) {
	if (state == ExpectedOutboundState.Completed) {
		return (green as any)[contrast];
	} else if (state == ExpectedOutboundState.Created) {
		return (purple as any)[contrast]
	} else if (state == ExpectedOutboundState.InProgress) {
		return (yellow as any)[contrast]
	} else if (state == ExpectedOutboundState.Canceled) {
		return (grey as any)[contrast]
	}
}

const ExpectedOutboundStateInline: React.FC<{
	state: ExpectedOutboundState
}> = ({ state }) => {
	let color = getExpectedOutboundStateColor(state);
	return <span style={{ color }}>{translate(state)}</span>;
}

export default ExpectedOutboundStateInline;
